/**
 * Created by Jaime Bonilla Venegas on 2017-06-23.
 *
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { List } from '../../components/data-containers';
import { Item } from './components';
import Form from '../../forms';
import * as actions from './actions';
import { SubHeader } from '../../components/layout';
import {
    reports as getReport
} from '../../services';
import { getPagePermissions, REPORTS_PERMISSION } from '../../security/permissions';

class Reportes extends Component {

    formHandler(open) {
        this.props.notify({ op: 'update', path: 'formOpen', value: open });
    }

    componentWillMount() {
        this.props.fetchCustomsHousesForListing('customsHouses', 'customsHouses', 'customsHouses/search/findAllByOrderByNameAsc');
        this.props.fetchCustomer('customers', 'customers', 'customers', { projection: 'denormalizedCustomer', sort: 'name', page: 0, size: 500, ['executiveUser.id']: isExecutive() ? this.props.userData.userId : '' });
        this.props.fetchStatus('statuses', 'statuses', 'clearenceStatuses?projection=clearenceStatusProjection');
        this.props.fetchUsers('users', 'usuarios', 'users?projection=usersProjection&page=0&size=500');
    }

    render() {
        const { formOpen, customsHouses = { items: [] }, customers = { items: [] }, statuses = { items: [] },reports, usuarios = { items: [] }, customsClearencesbyAduana = [], customsClearencesbyCustomer = [], customsClearencesbyStatus = [], customsClearencesbyUser = [], pagePermissions } = this.props;
        return (
            <div>
                <SubHeader
                    title="Reportes"
                    showRefresh={false} //use this property when fetching data
                    onPressHeaderButton={() => this.formHandler(false)}
                    showAddButton={false} //not needed
                />
                <div>
                    <List
                        data={[{ id: '1' }]}
                        renderItem={(item) => <Item
                            {...item}
                            customsHouses={customsHouses && customsHouses.items}
                            customers={customers && customers.items}
                            statuses={statuses && statuses.items}
                            usuarios={usuarios && usuarios.items}
                            customsClearencesbyAduana={customsClearencesbyAduana}
                            customsClearencesbyCustomer={customsClearencesbyCustomer}
                            customsClearencesbyStatus={customsClearencesbyStatus}
                            customsClearencesbyUser={customsClearencesbyUser}
                            actions={{
                                getCustomsClearence: (value, buttonValue) => {
                                    this.props.fetchReports('reports', 'reports', {value,buttonValue});
                                },
                                getInfoBy: (value, updatePath) => {
                                    this.props.fetchcustomsClearence(value, updatePath)
                                }
                            }}
                        />}

                    />
                </div>
                {/*
                <Form
                    title="Crear Nuevo Usuario"
                    type="user"
                    open={formOpen}
                    actions={{}}
                    onModalClosed={() => this.formHandler(false)}
                    onSave={(form) => {
                        console.log('Form notifies until the form is valid', form);
                        this.formHandler(false);
                    }}//Will return if form is valid to send it
                />*/}
            </div>
        );
    }
}

const mapStateToProps = ({ users, userData, userData: { permissions } }) => {
    return {
        ...users,
        userData,
        pagePermissions: getPagePermissions(REPORTS_PERMISSION, permissions)
    };
};

export default connect(mapStateToProps, { ...actions })(Reportes);



// WEBPACK FOOTER //
// ./containers/reportes/index.js